/**
 * Whole-day arithmetic on UTC calendar days.
 *
 * Freshness and inheritance are expressed in days ("179 days ago inherits, 400 does
 * not"). Computing that from millisecond differences makes the answer depend on the
 * clock time of day and on DST, so an audit created at 09:00 would inherit an item
 * that the same audit created at 17:00 would not. Everything here truncates to the
 * UTC calendar day first.
 */

const MS_PER_DAY = 86_400_000;

/** Midnight UTC on the calendar day of `d`. */
export function startOfUtcDay(d: Date): Date {
  return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));
}

/** Whole UTC days from `from` to `to`. Negative when `to` is earlier. */
export function daysBetween(from: Date, to: Date): number {
  return Math.round((startOfUtcDay(to).getTime() - startOfUtcDay(from).getTime()) / MS_PER_DAY);
}

export function addDays(d: Date, days: number): Date {
  return new Date(startOfUtcDay(d).getTime() + days * MS_PER_DAY);
}

/** True when both dates fall on the same UTC calendar day. */
export function isSameUtcDay(a: Date, b: Date): boolean {
  return startOfUtcDay(a).getTime() === startOfUtcDay(b).getTime();
}
